import { lightBlue } from './variables'

const theme = {
  global: {
    font: {
      family: 'IBM Plex Sans',
    },
    colors: {
      brand: '#2980B9',
    },
    focus: {
      border: {
        color: lightBlue,
      },
    },
  },
  text: {
    medium: {
      size: '14px',
    },
  },
  button: {
    border: {
      radius: '5px',
    },
  },
}

export default theme
